/**
 * Reload the app.  Uses window.location.reload() which works correctly
 * in both regular browsers and Capacitor WebViews.
 *
 * Previously this used location.replace(location.href) for Capacitor,
 * but that is a no-op when the URL contains a hash fragment (#chat),
 * which broke all reload paths in the production PWA.
 */

export function reloadApp(): void {
  window.location.reload();
}

